<template>
    <div class="contentbox installationfee">
      <!--@click="onsave"-->
      <div class="setaddressbox" @click="onsave">
        <ul>
          <li :key="itme.i_id" v-for="(itme) in options2">
            <div>
              <div @click="showchild(itme.i_id)">{{itme.i_name}} <span :class="itme.showchild?'open':''" class="arrow el-icon-arrow-right"></span></div>
              <div v-if="!itme.sonData">
                <p>{{itme.i_currency}} {{itme.i_price}}</p>
                <p>
                  <Num
                    @change="onsave"
                    v-model="itme.num"
                    :min="1" />
                </p>
                <p @click="selectinstall(itme.i_id)">
                  <Dot :state="itme.state" :bacolor="true">
                    <!--<slot>√</slot>-->
                  </Dot>
                </p>
              </div>
            </div>
            <!--第二层-->
            <ul v-show="itme.showchild">
              <li :key="itme2.i_id" v-for="(itme2) in itme.sonData">
                <div>
                  <div @click="showchild(itme2.i_id)">{{itme2.i_name}} <span :class="itme2.showchild?'open':''" class="arrow el-icon-arrow-right"></span></div>
                  <div v-if="!itme2.sonData">
                    <p>{{itme2.i_currency}} {{itme2.i_price}}</p>
                    <p>
                      <Num
                        @change="onsave"
                        v-model="itme2.num"
                        :min="1" />
                    </p>
                    <p @click="selectinstall(itme2.i_id)">
                      <Dot :state="itme2.state" :bacolor="true">
                        <!--<slot>√</slot>-->
                      </Dot>
                    </p>
                  </div>
                </div>
                <!--第三层-->
                <ul v-show="itme2.showchild">
                  <li :key="itme3.i_id" v-for="(itme3) in itme2.sonData">
                    <div>
                      <div>{{itme3.i_name}}</div>
                      <div v-if="!itme3.sonData">
                        <p>{{itme3.i_currency}} {{itme3.i_price}}</p>
                        <p>
                          <Num
                            @change="onsave"
                            v-model="itme3.num"
                            :min="1" />
                        </p>
                        <p @click="selectinstall(itme3.i_id)">
                          <Dot :state="itme3.state" :bacolor="true">
                            <!--<slot>√</slot>-->
                          </Dot>
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
  import { Checklist } from 'mint-ui';
  import Num from '../Num/Num'
  import Dot from '../Dot/Dot'
  import {commitInstallationCharge} from '../../assets/js/api'
    export default {
        name: "Installationfee",
        data(){
          return{
            options2:[] //带数字的安装费
          }
        },
        components:{
          Checklist,
          Num,
          Dot
        },
        mounted(){
          commitInstallationCharge().then((data)=>{
            // console.log(data)
            if (data.status){
              if (data.data){
                data.data.map(itme=>{
                  itme.state = false
                  itme.num = 1
                  itme.showchild = false
                  // 回写第一层的安装费
                  if (this.$store.state.userdata.installationfee.length){
                    this.$store.state.userdata.installationfee.map(list=>{
                      if (itme.i_id === list.i_id){
                        itme.num = Number(list.num)
                        itme.state = true
                      }
                    })
                  }
                  // 第二层
                  if (itme.sonData){
                    itme.sonData.map(itme2=>{
                      itme2.state = false
                      itme2.num = 1
                      itme2.showchild = false
                      // 回写第二层的安装费
                      if (this.$store.state.userdata.installationfee.length){
                        this.$store.state.userdata.installationfee.map(list=>{
                          if (itme2.i_id === list.i_id){
                            itme2.num = Number(list.num)
                            itme2.state = true
                          }
                        })
                      }
                      // 第三层
                      if (itme2.sonData){
                        itme2.sonData.map(itme3=>{
                          itme3.state = false
                          itme3.num = 1
                          itme3.showchild = false
                          // 回写第三层的安装费
                          if (this.$store.state.userdata.installationfee.length){
                            this.$store.state.userdata.installationfee.map(list=>{
                              if (itme3.i_id === list.i_id){
                                itme3.num = Number(list.num)
                                itme3.state = true
                              }
                            })
                          }
                        })
                      }
                    })
                  }
                  this.options2.push(itme)
                })
              }
            }
          })
        },
        methods:{
          onsave(){
            setTimeout(()=>{
              let installationfee = []
              this.options2.map(itme=>{
                if (itme.state){
                  installationfee.push(itme)
                }
                if (itme.sonData) {
                  itme.sonData.map(itme2=>{
                    if (itme2.state){
                      installationfee.push(itme2)
                    }
                    if (itme2.sonData) {
                      itme2.sonData.map(itme3=>{
                        if (itme3.state){
                          installationfee.push(itme3)
                        }
                      })
                    }
                  })
                }
              })
              this.$store.commit('setinstallationfee',installationfee)
              this.$emit('changeinstallationfee')
            })
          },
          selectinstall(id){
            this.options2.map(itme=>{
              if (itme.i_id === id){
                itme.state?itme.state = false : itme.state = true
              }
              // 第二层
              else if (itme.sonData) {
                itme.sonData.map(itme2=>{
                  if (itme2.i_id === id){
                    itme2.state?itme2.state = false : itme2.state = true
                  }
                  // 第三层
                  else if (itme2.sonData) {
                    itme2.sonData.map(itme3=>{
                      if (itme3.i_id === id){
                        itme3.state?itme3.state = false : itme3.state = true
                      }
                    })
                  }
                })
              }
            })
            this.onsave()
          },
          // 展开子层
          showchild(id){
            this.options2.map(itme=>{
              // if (itme.showchild) {}
              if (itme.i_id === id){
                itme.showchild = !itme.showchild
              }
              if (itme.sonData) {
                itme.sonData.map(itme2=>{
                  if (itme2.i_id === id){
                    itme2.showchild = !itme2.showchild
                  }
                })
              }
            })
          }
        },
        computed:{
        }
    }
</script>

<style lang="less">
  @import "../../assets/less/base";

  .contentbox.installationfee{
    background-color: #fff;
    width: 100%;
    .setaddressbox{
      width: 100%;
      background: #fff;
      .mint-checklist-label{
        cursor: pointer;
        padding: 16px 10px;
      }
      ul{
        padding: 10px;
        li{
          .arrow{
            font-size: 20px;
            transition: all 0.5s;
            margin-left: 0.1rem;
          }
          .open{
            transform:rotate(90deg);
          }
          >div{
            display: flex;
            justify-content: space-between;
            justify-items: center;
            padding: 10px;
            div{
              display: flex;
              justify-content: space-between;
              justify-items: center;
              p{
                width: 30%;
                text-align: center;
              }
            }

          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/assembly/Installationfee/Installationfee.vue